import { IGetDataParams, ITrialVideo, ITrialMaterial, IEntityPerson, IEngagement } from '@shared/interfaces/interfaces';
import { autoinject } from 'aurelia-framework';
import { Repository } from '@data/repository';
import { getEntityManager, createEntityManagerAsync } from '@data/entity-manager-factory';
import { SentryValueConverter } from '@shared/value-converters/sentry';
// import { EntityAspect } from 'breeze';

@autoinject
export class Lookups {
  events: any;
  private repository: Repository;
  private sentry: SentryValueConverter;
  public trialVideos: ITrialVideo[] = [];
  public trialMaterials: ITrialMaterial[] = [];

  constructor(repository: Repository, sentry: SentryValueConverter) {
    this.repository = repository;
    this.sentry = sentry;
  }

  async getData(spaName: string, context?: string) {

    if (!this.repository.breezeManager) {
      await createEntityManagerAsync();
      this.repository.breezeManager = getEntityManager();
    }

    const getDataParams: IGetDataParams = {
      apiMethod: `Lookups_${spaName}`,
      filterName: '',
      filterValue: '',
      forceRemote: true,
    };

    let failed: boolean = false;
    let error: string = '';

    const response = await this.repository.getData(getDataParams, `${context ? `${context} => ` : ''}_data.lookups.getData (${spaName})`)
      .catch((err) => {
        // TODO - mirror approach to repo error in basket.ts once tested
        console.log(`Error - status = ${err.status}`);
        // const reportError = this.sentry.toView(
          // `lookups.getData error (${spaName}). Status: ${err.status}`,
          // err);
        // this.error = 'Error retrieving data';
        failed = true;
        error = err;
        // 404 = controller method not allowed (i.e. user not logged in or not admin)
        // Or not found (should never happen)
        // 406 = token error (probably other tabs open so reload?)
        // 405 = data not found
        // don't reload because lookups are called by apps, which are only run once on spa load
        // if (err.status === 406 || err.status === 404) {
        // window.location.reload();
        // }
      });

    if (failed || !response) {
      return Promise.reject(error);
    }

    return Promise.resolve(response);

  }

  async getPerson(personId: string, forceRemote: boolean, context?: string):
    Promise<breeze.Entity[]> {

    if (!this.repository.breezeManager) {
      await createEntityManagerAsync();
      this.repository.breezeManager = getEntityManager();
    }

    const getDataParams: IGetDataParams = {
      forceRemote,
      apiMethod: 'Persons',
      filterName: 'personId',
      filterValue: personId,
      checkFetched: true,
    };

    let failed: boolean = false;
    let error: string = '';

    const response = await this.repository.getData(getDataParams, `${context ? `${context} => ` : ''}_data.lookups.getPerson`)
      .catch((err) => {
        // TODO - mirror approach to repo error in basket.ts once tested
        console.log(`Error - status = ${err.status}`);
        const reportError = this.sentry.toView(
          `lookups.getPerson error (${personId}). Status: ${err.status}`,
          err);
        // this.loadError = `Error retrieving data: ${err.status}`;
        failed = true;
        error = err;
        // 404 = controller method not allowed (i.e. user not logged in or not admin)
        // Or not found (should never happen)
        // 406 = token error (probably other tabs open so reload?)
        // 405 = data not found
        // don't reload because lookups are called by apps, which are only run once on spa load
        // if (err.status === 406 || err.status === 404) {
        // window.location.reload();
        // }
      });

    if (failed || !response) {
      return Promise.reject(error);
    }

    return Promise.resolve(<breeze.Entity[]>response);

  }

  buildTrialUsage(engagements: any[]) {

    this.trialVideos = [];
    this.trialMaterials = [];

    const vTrackers: IEngagement[] = engagements.filter(
      t => t.resourceGroupVideoId &&
      t.resourceGroup.resourceType &&
      t.resourceGroup.resourceType.name.toLowerCase().indexOf('box') > -1);
    let existingVideo: ITrialVideo[];
    let newVideo: ITrialVideo;
    for (const vTracker of vTrackers) {
      existingVideo =
        this.trialVideos.filter(e => e.videoId === vTracker.resourceGroupVideoId);
      if (existingVideo.length === 0 && vTracker.resourceGroupVideoId) {
        newVideo = {
          videoId: vTracker.resourceGroupVideoId,
        };
        this.trialVideos.push(newVideo);
      }
    }
    // console.log('TrialVideos');
    // console.log(this.trialVideos);

    const mTrackers: IEngagement[] =
      engagements.filter(
        t => t.resourceGroupMaterialId &&
        t.resourceGroup.resourceType &&
        t.resourceGroup.resourceType.name.toLowerCase().indexOf('box') > -1);
    let existingMaterial: ITrialMaterial[];
    let newMaterial: ITrialMaterial;
    for (const mTracker of mTrackers) {
      existingMaterial =
        this.trialMaterials.filter(e => e.materialId === mTracker.resourceGroupMaterialId);
      if (existingMaterial.length === 0 && mTracker.resourceGroupMaterialId) {
        newMaterial = {
          materialId: mTracker.resourceGroupMaterialId,
        };
        this.trialMaterials.push(newMaterial);
      }
    }
    // console.log('TrialMaterials');
    // console.log(this.trialMaterials);

  }

  async getTrackers(personId: string, forceRemote: boolean, context?: string):
    Promise<breeze.Entity[]> {

    if (!this.repository.breezeManager) {
      await createEntityManagerAsync();
      this.repository.breezeManager = getEntityManager();
    }

    const getDataParams: IGetDataParams = {
      forceRemote,
      apiMethod: 'PersonTrackers',
      filterName: 'personId',
      filterValue: personId,
      checkFetched: true,
    };

    let failed: boolean = false;
    let error: string = '';

    const response = await this.repository.getData(getDataParams, `${context ? `${context} => ` : ''}_data.lookups.getTrackers`)
      .catch((err) => {
        // TODO - mirror approach to repo error in basket.ts once tested
        console.log(`Error - status = ${err.status}`);
        const reportError = this.sentry.toView(
          `lookups.getTrackers error (${personId}). Status: ${err.status}`,
          err);
        // this.loadError = `Error retrieving data: ${err.status}`;
        failed = true;
        error = err;
        // 404 = controller method not allowed (i.e. user not logged in or not admin)
        // Or not found (should never happen)
        // 406 = token error (probably other tabs open so reload?)
        // 405 = data not found
        // don't reload because lookups are called by apps, which are only run once on spa load
        // if (err.status === 406 || err.status === 404) {
        // window.location.reload();
        // }
      });

    if (failed || !response) {
      return Promise.reject(error);
    }

    // console.log(response);
    const responseData: any = response[0];
    const eTrackers: any[] = responseData.engagementTrackers;
    this.buildTrialUsage(eTrackers);

    return Promise.resolve(<breeze.Entity[]>response);

  }

}
